import { render, staticRenderFns } from "./Plandetail.vue?vue&type=template&id=10c5e4a9&scoped=true"
import script from "./Plandetail.vue?vue&type=script&lang=js"
export * from "./Plandetail.vue?vue&type=script&lang=js"
import style0 from "./Plandetail.vue?vue&type=style&index=0&id=10c5e4a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c5e4a9",
  null
  
)

export default component.exports